import { rem } from 'polished';
import styled, { keyframes } from 'styled-components';

import { ISpinnerProps } from './Spinner.types';

const rotate = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

export const StyledWrapper = styled.div<ISpinnerProps>`
  width: ${({ size }) => size && rem(size)};
  height: ${({ size }) => size && rem(size)};
  border-width: ${({ strokeSize }) => strokeSize && rem(strokeSize)};
  border-style: solid;
  border-color: ${({ backgroundColor }) => backgroundColor && backgroundColor};
  border-top-color: ${({ foregroundColor }) =>
    foregroundColor && foregroundColor};
  border-radius: 50%;
  animation: ${rotate} ${({ speed }) => speed && speed}s linear infinite;
`;
